export default __webpack_public_path__ + "static/6-2--6a897b86ee1b99b67d6060d88585d2e1.png";